module.exports = __webpack_public_path__ + "sl.57cb91fca68e8a881972.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sl.svg
// module chunks = styles